module.exports = __webpack_public_path__ + "static/productionI-mobile-7799eb3b4a9e9b3ef4de34a403baee81.svg";